// src/Pages/Home.jsx
import * as React from "react";
import { Link } from "react-router-dom";
import { ThemeProvider, createTheme, Box, Typography, Stack, Badge } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import Footer from "./Footer";
import { countUpcoming } from "../data/events"; // ← pulls the number

export default function Home() {
  const theme = createTheme({
    typography: {
      h1: { fontFamily: "Helvetica", fontSize: "2.2rem" },
      h5: { fontFamily: "Helvetica", fontSize: "1.6rem", fontWeight: 200 },
    },
  });

  const sm = useMediaQuery(theme.breakpoints.down("sm"));

  // how many upcoming gigs (0 hides the badge below)
  const gigCount = countUpcoming();

  return (
    <ThemeProvider theme={theme}>
      <Box
        sx={{
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          m: 0,
          p: 0,
        }}
      >
        {/* Main band */}
        <Box
          sx={{
            flex: 1,
            display: "flex",
            flexDirection: sm ? "column" : "row",
            alignItems: "center",
            justifyContent: "space-between",
            px: sm ? "6vw" : "10vw",
            pt: sm ? "5vh" : 0,
            gap: sm ? "4vh" : 0,
          }}
        >
          {/* Logo container */}
          <Box
            sx={{
              flex: sm ? "0 0 auto" : "1 1 0",
              display: "flex",
              justifyContent: sm ? "center" : "flex-start",
              alignItems: "center",
              width: sm ? "100%" : "auto",
            }}
          >
            <Box
              component="img"
              src="/logo.gif"
              alt="Logo"
              sx={{
                height: sm ? "auto" : "45vh",
                width: sm ? "72%" : "auto",
                maxWidth: sm ? "420px" : "none",
                filter: "url(#inkBleed)",
                WebkitFilter: "url(#inkBleed)",
              }}
            />
          </Box>

          {/* Right side: title + nav */}
          <Stack
            direction="column"
            spacing={sm ? 4 : 8}
            alignItems="flex-end"
            sx={{
              flex: sm ? "0 0 auto" : "1 1 0",
              mb: sm ? "8vh" : 0,
              width: sm ? "100%" : "auto",
              textAlign: "right",
              pr: sm ? 0 : "2vw",
              mr: sm ? "30vw" : 0, // your mobile tweak
            }}
          >
            {/* Title */}
            <Typography variant="h1">Leonid Pesenti</Typography>

            {/* Links */}
            <Stack spacing={4} alignItems="flex-end" sx={{ width: "100%" }}>
              <Link to="/about" style={{ color: "black" }}>
                <Typography variant="h5">about</Typography>
              </Link>

              <Link to="/events" style={{ color: "black", textDecoration: "underline" }}>
                {gigCount > 0 ? (
                  <Badge
                    badgeContent={gigCount}
                    sx={{
                      "& .MuiBadge-badge": {
                        backgroundColor: "rgb(234, 79, 61)",
                        color: "white",
                        fontSize: "0.7rem",
                        fontWeight: 600,
                        fontFamily: "Helvetica, Arial, sans-serif",
                        height: 18,
                        minWidth: 18,
                        borderRadius: "50%",
                        top: 5,
                        right: -10,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      },
                    }}
                  >
                    <Typography variant="h5" sx={{ textDecoration: "underline" }}>
                      events
                    </Typography>
                  </Badge>
                ) : (
                  <Typography variant="h5" sx={{ textDecoration: "underline" }}>
                    events
                  </Typography>
                )}
              </Link>

              <Link to="/music" style={{ color: "black" }}>
                <Typography variant="h5">music</Typography>
              </Link>
              <Link to="/ph" style={{ color: "black" }}>
                <Typography variant="h5">photography</Typography>
              </Link>
              <Link to="/writing" style={{ color: "black" }}>
                <Typography variant="h5">writing</Typography>
              </Link>
              <Link to="/contact" style={{ color: "black" }}>
                <Typography variant="h5">contact</Typography>
              </Link>
            </Stack>
          </Stack>
        </Box>

        {/* Footer */}
        <Box sx={{ display: "flex", justifyContent: "center", pb: "3vh" }}>
          <Footer />
        </Box>
      </Box>
    </ThemeProvider>
  );
}
